export const truncateString = (text, maxLength, rep = '..') => {
  if (!text || text.length < maxLength) {
    return text;
  }

  return text.slice(0, maxLength - rep.length).trim() + rep;
};
